import GroupCardAccordion from './GroupCardAccordion';

export default GroupCardAccordion;
